import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { DRAG_DROP_PASTE } from '@lexical/rich-text';
import { COMMAND_PRIORITY_LOW } from 'lexical';
import { useEffect } from 'react';

const ACCEPTABLE_IMAGE_TYPES = ['image/', 'image/heic', 'image/heif', 'image/gif', 'image/webp'];

export default function DragDropPastePlugin(): null {
  const [editor] = useLexicalComposerContext();
  useEffect(() => editor.registerCommand(DRAG_DROP_PASTE, (files) => true, COMMAND_PRIORITY_LOW), [editor]);
  return null;
}
